import { render, staticRenderFns } from "./RelMembrosKids.vue?vue&type=template&id=03ec04b8"
import script from "./RelMembrosKids.vue?vue&type=script&lang=js"
export * from "./RelMembrosKids.vue?vue&type=script&lang=js"
import style0 from "./RelMembrosKids.vue?vue&type=style&index=0&id=03ec04b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports